import { BUNDLE_BEAN, PACKAGE_BEAN } from '../../constants/constants';

export const getFlagsForAnchorMenu = (
  data,
  showContentForNonSoftwarePart = true
) => {
  const filterByEquipmentEnabled = data.isFilterByEquipmentEnabled;
  const productType = data.type;
  const isPackage = productType === PACKAGE_BEAN;
  const isBundle = productType === BUNDLE_BEAN;
  const isPackageOrBundle = isPackage || isBundle;
  const isPartDiagramShow =
    filterByEquipmentEnabled &&
    !isPackageOrBundle &&
    showContentForNonSoftwarePart;

  return {
    isPartDiagramShow,
    filterByEquipmentEnabled
  };
};

export const numberOfAttribuesToDisplay = 3;
export const initialIndex = 0;

export const shouldShowMobilePartsDiagramV2 = (
  isPccReleasePartsDiagramVersionTwoFlag: boolean,
  isMobile: boolean
) => isPccReleasePartsDiagramVersionTwoFlag && isMobile;

export const getPricePartsList = (diagramData) => {
  return diagramData?.lineItems?.map((item) => ({
    partNumber: `${item.partNumber.slice(0, -4)}-${item.partNumber.slice(-4)}`,
    quantity: item.quantity.trim().length === 0 ? '1' : item.quantity
  }));
};

export const extractNumericIndex = (
  refNumber: string | number | null | undefined
) => {
  if (!refNumber) return null;
  const numericPart = refNumber.toString().match(/^\d+/);
  return numericPart ? parseInt(numericPart[0], 10) : null;
};

export const parsePriceToFloat = (priceString?: string | null): number => {
  if (!priceString) return 0;
  return parseFloat(priceString.replace(/[$,]/g, '')) || 0;
};
